module.exports = __webpack_public_path__ + "static/media/ic_update_status.0076bf1b.svg";